import { useSessionCtx } from "../../context/SessionContext";

export function useQnaPage() {
  const ctx = useSessionCtx();
  if (!ctx) return { qna: [], qnaToggle: () => {}, clearQnaChannel: () => {}, activeCount: 0, totalCount: 0, isReady: false };
  const qna = Array.isArray(ctx.qna) ? ctx.qna : [];
  const qnaToggle = ctx.qnaToggle ?? (() => {});
  const clearQnaChannel = ctx.clearQnaChannel ?? (() => {});
  const activeCount = qna.filter((q) => q.isApproved).length;
  const totalCount = qna.length;
  return { qna, qnaToggle, clearQnaChannel, activeCount, totalCount, isReady: true };
}
